import { useEffect, useRef } from 'react';

import { useChatHistoryQuery } from 'features/participants/hooks/query/useChatHistory';

type LoadFirstUnreadMessageTimeProps = {
  unreadChatMessagesNumber: number;
  lastReadMessageId: string;
  chatId: string;
};

export const useLoadFirstUnreadMessage = ({
  chatId,
  unreadChatMessagesNumber,
  lastReadMessageId,
}: LoadFirstUnreadMessageTimeProps) => {
  const hasLoadedRef = useRef(false);

  const shouldFetch = unreadChatMessagesNumber > 0 && !hasLoadedRef.current;

  // load first unread message
  const { data: chatMessages = [] } = useChatHistoryQuery({
    chatId,
    enabled: shouldFetch,
    fromMessageId: lastReadMessageId,
    direction: 'down',
    limit: 1,
  });

  // Mark as loaded once we have data
  useEffect(() => {
    if (chatMessages.length > 0 && !hasLoadedRef.current) {
      hasLoadedRef.current = true;
    }
  }, [chatMessages.length]);

  return chatMessages.length > 0 ? chatMessages[chatMessages.length - 1] : null;
};
